import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppSvgIconComponent } from '@vallift/ngl';
import { RespondentTokenStorageService } from '@core/services/respondent-token-storage.service';

@Component({
  selector: 'app-respondent-account-menu-button',
  standalone: true,
  imports: [AppSvgIconComponent],
  templateUrl: './respondent-account-menu-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RespondentAccountMenuButtonComponent {
  private readonly respondentTokenStorage = inject(RespondentTokenStorageService);
  private readonly router = inject(Router);

  get email(): string {
    return this.respondentTokenStorage.getProfile()?.email?.trim() ?? '';
  }

  get displayName(): string {
    const name = this.respondentTokenStorage.getProfile()?.displayName?.trim();
    if (name) {
      return name;
    }
    return this.email || 'Account';
  }

  get pictureUrl(): string | null {
    return this.respondentTokenStorage.getProfile()?.picture?.trim() || null;
  }

  get initial(): string {
    const source = this.displayName;
    return source ? source.charAt(0).toUpperCase() : 'U';
  }

  onLogout(): void {
    this.respondentTokenStorage.clearSession();
    void this.router.navigate(['/my-forms']);
  }
}
